import { render, staticRenderFns } from "./WorktypePoints.vue?vue&type=template&id=6a723704&scoped=true"
import script from "./WorktypePoints.vue?vue&type=script&lang=js"
export * from "./WorktypePoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a723704",
  null
  
)

export default component.exports